import { Footer } from "./footer-section";

export default function DemoFooter() {
  return <Footer />;
}

